import { render } from "./Separator.vue?vue&type=template&id=7d427087"
const script = {}

import "./Separator.vue?vue&type=style&index=0&id=7d427087&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__